/**
 * Re-exports from the canonical implementation in `@atlassian/post-office-context`.
 *
 * The source of truth is:
 *   platform/packages/post-office/post-office-context/src/message-lifecycle/message-event-client.ts
 *
 * This re-export ensures that `@post-office/message-lifecycle` and
 * `@atlassian/post-office-context` share the same `MessageEventClient` class
 * identity, avoiding TypeScript structural mismatch errors caused by private fields.
 */
export { MessageEventClient } from '@atlassian/post-office-context/message-event-client';
export type {
	MessageEventPostPayload,
	InAppMessageEventType,
	PostOfficeContext,
} from '@atlassian/post-office-context/message-event-client';
